import { ArrowRight } from "lucide-react";
import { SectionLabel } from "@/features/simulations/sandbox/results/result-primitives";
import type { InterpretationNextStep } from "@/types/interpretation.types";

// Próximos passos recomendados (≥1 quando a rodada está concluída). No canal de tela são guias de
// ação; quando abertos pelo assistente, viram propostas de comando confirmáveis (dock).

export function NextStepsSection({
  steps,
}: {
  steps: InterpretationNextStep[];
}): React.ReactElement | null {
  if (steps.length === 0) return null;
  return (
    <section>
      <SectionLabel>Próximos passos</SectionLabel>
      <ul className="space-y-1.5">
        {steps.map((s, i) => (
          <li key={i} className="flex items-start gap-2 text-[13px] text-text-secondary">
            <ArrowRight className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-500" aria-hidden />
            <span>{s.label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
